export default __webpack_public_path__ + "c32e60b22e97dcb71c1aec4f989dbe51.svg";